import CommonHeader from '../pages/Head'
import React from 'react'
import axios from 'axios';


class SetupOperation extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {manageaction:'TEST',user:localStorage.getItem('tokens'), Resp:'',accountid:''};							
		this.handleChange=this.handleChange.bind(this)
		this.handleSubmit=this.handleSubmit.bind(this)
	}
	
	handleChange = event => {				
		const {name, value} = event.target
		this.setState({[name]: value}) 		
		this.setState({Resp:''})
	}

	handleSubmit = event => {
		event.preventDefault()		
		const {accountid} = this.state		
		if(!accountid){
			alert('Please enter AccountID or ProfileID for testing')
			return false 
		} 
		const userObject = {	
			user:this.state.user,
			accountid:this.state.accountid
		};
		axios.post(process.env.REACT_APP_API_ENV+'api/autoprocess.php', userObject)
			.then((res) => {
				this.setState({Resp:res.data})											
			}).catch((error) => {
				console.log(error)
			});
		
	}
	render() {		
		return(
			<div style={{textAlign:'center'}}>
				<CommonHeader titles="Auto Run"/>	
				<form onSubmit={this.handleSubmit}>
					<h3>Enter ProfileID</h3>
					<input name="accountid" style={{width: '150px', border:'1px solid grey'}} value = {this.state.accountid} onChange={this.handleChange} />
					<br/><br/>					
					<h3>{this.state.Resp}</h3><br/><br/>
					<button className="btn btn-success btn-block" style={{fontSize:'150%'}}>Submit</button><br/><br/>
				</form>				
			</div>
		)
	}
}

export default SetupOperation